import React from 'react';
import { Typography, Paper } from '@mui/material';

function TermsPage() {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Terms & Conditions</Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>1. Acceptance of Terms</Typography>
      <Typography variant="body1" paragraph>
        By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>2. User Conduct</Typography>
      <Typography variant="body1" paragraph>
        Users agree not to post any false, misleading, or malicious information. Any fraudulent activity will result in immediate account termination and potential legal action.
      </Typography>
      <Typography variant="h6" sx={{ mt: 2 }}>3. Limitation of Liability</Typography>
      <Typography variant="body1" paragraph>
        This platform is provided "as is". We are not responsible for any disputes, losses, or damages that may arise between users. We do not verify the authenticity of posts or users.
      </Typography>
    </Paper>
  );
}

export default TermsPage;
